import { render, staticRenderFns } from "./user-identification.vue?vue&type=template&id=5d504d5e&scoped=true"
import script from "./user-identification.vue?vue&type=script&lang=js"
export * from "./user-identification.vue?vue&type=script&lang=js"
import style0 from "./user-identification.vue?vue&type=style&index=0&id=5d504d5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d504d5e",
  null
  
)

export default component.exports